import { translate } from '@shakkerai/util-i18n';

export const defaultStyle = {
  imageUrl:
    'https://models-online-persist.shakker.ai/img/fb61b1d78e1a4f69ac22cc70860b6243/e87735ced1ed4b016f7f2d640a4c2b20754f9fbb83f6b8adb150132a76204e6c.png',
  tagLabelList: ['', translate('style_default')],
  title: translate('style_default'),
};

export const defaultModel = {
  baseType: 'SD XL',
  name: translate('model_default'),
  imageUrl:
    'https://models-online-persist.shakker.ai/img/fb61b1d78e1a4f69ac22cc70860b6243/b86a364b482883be4a2fff6d1aa5a1e86d22b31d19a1776ebdd82aafc092933f.png',
};

export const imageToolStylesMap = {
  Unknown: {
    inpaint: 'common',
    upscale: '1',
    outpaint: 'common',
    changeFace: 'common',
  },
  'Anime style': { inpaint: 'anime', upscale: '2', outpaint: 'anime', changeFace: 'anime' },
  'Floppy comic style': { inpaint: 'anime', upscale: '2', outpaint: 'anime', changeFace: 'anime' },
  'American Comic style': { inpaint: 'anime', upscale: '2', outpaint: 'anime', changeFace: 'anime' },
  'Portrait Photography': {
    inpaint: 'photography',
    upscale: '1',
    outpaint: 'common',
    changeFace: 'common',
  },
  'Landscape Photography': {
    inpaint: 'common',
    upscale: '1',
    outpaint: 'common',
    changeFace: 'common',
  },
  'Surreal / abstract photography': {
    inpaint: 'common',
    upscale: '1',
    outpaint: 'common',
    changeFace: 'common',
  },
  'Nature Photography': {
    inpaint: 'common',
    upscale: '1',
    outpaint: 'common',
    changeFace: 'common',
  },
  'Street Photography': {
    inpaint: 'common',
    upscale: '1',
    outpaint: 'common',
    changeFace: 'common',
  },
  'Traditional Painting Media': {
    inpaint: 'illustration',
    upscale: '4',
    outpaint: 'illustration',
    changeFace: 'illustration',
  },
  'Digital Painting Media': {
    inpaint: 'illustration',
    upscale: '4',
    outpaint: 'illustration',
    changeFace: 'illustration',
  },
  'Product Poster': {
    inpaint: 'common',
    upscale: '3',
    outpaint: 'game_cg',
    changeFace: 'common',
  },
  'Logo Design': {
    inpaint: 'illustration',
    upscale: '3',
    outpaint: 'game_cg',
    changeFace: 'illustration',
  },
  'Background asset': {
    inpaint: 'game_cg',
    upscale: '3',
    outpaint: 'game_cg',
    changeFace: 'common',
  },
  'Game asset': {
    inpaint: 'game_cg',
    upscale: '3',
    outpaint: 'game_cg',
    changeFace: 'common',
  },
  'Cartoon style': {
    inpaint: '3d',
    upscale: '5',
    outpaint: '3d',
    changeFace: '3d',
  },
  'CGI style': {
    inpaint: '3d',
    upscale: '5',
    outpaint: '3d',
    changeFace: '3d',
  },
  'Architectural Design': {
    inpaint: 'common',
    upscale: '3',
    outpaint: 'game_cg',
    changeFace: 'common',
  },
  'Interior Design': {
    inpaint: 'common',
    upscale: '3',
    outpaint: 'game_cg',
    changeFace: 'common',
  },
  'Landscape Design': {
    inpaint: 'common',
    upscale: '3',
    outpaint: 'game_cg',
    changeFace: 'common',
  },
};
